
      // Inject GTM ID from environment variable
      const gtmId = import.meta.env.VITE_GTM_CONTAINER_ID;
      const gtmScript = document.createElement('script');
      gtmScript.text = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(gtmScript);

      // Update noscript iframe
      const noscriptIframe = document.querySelector('#gtm-noscript');
      if (noscriptIframe) {
        noscriptIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      }
    